// extracted by mini-css-extract-plugin
module.exports = {"customerSwiper":"CustomerSwiper_customerSwiper__MIByT"};